















































































































































import VueElementLoading from "vue-element-loading"
import VueDraggable from 'vuedraggable'
import { Vue, Component, Prop } from 'vue-property-decorator'
import { vue as i18n } from "@/services/i18n"
import { nameMap } from '@/modules/budget/monitoring/reports-constructor/common/nameMap'
import { cloneDeep } from "lodash"
import { Classificator } from "../../../common/types/Classificator"
import { Indicator } from "../../../common/types/Indicator"
import { formatDigitsGrouping, padLeadingZeros } from "../../../common/utils/formattingUtils"
import { Report127DailyRow, Report127DailyTableRow, SectionSeparator } from "../table-data/table-data-types"
import { ExpenseType } from "../../../common/types/roots/fields"

interface Section {
    key: string,
    value: any[]
}

export interface TableField {
    key: string,
    label: string,
    active: boolean,

    income?: string,
    expense?: string,
    classification?: string
}

@Component({
    components: {
        'draggable': VueDraggable,
        'loading': VueElementLoading
    }
})
export default class Report127Daily extends Vue {

    @Prop({
        type: Array,
        required: true,
    })
    public readonly tableData!: Report127DailyRow[]

    @Prop({
        type: Array,
        required: true,
        default: [],
    })
    private readonly incomes!: Classificator[]

    @Prop({
        type: Array,
        required: true,
        default: [],
    })
    private readonly expenses!: Classificator[]

    @Prop({
        type: Array,
        required: true,
        default: [],
    })
    private readonly propIndicators!: Indicator[]

    @Prop({
        type: String,
        required: true,
        default: '',
    })
    private readonly expenseType!: ExpenseType

    @Prop({
        type: Array,
        default: () => [],
    })
    private readonly segmentations!: string[]

    i18nService = i18n

    public tableFields: TableField[] = []
    public categoryFields: TableField[] = []
    public indicators: Indicator[] = []

    public currentPage = 1
    public selectedRegion: Section | null = null
    public selectedSection: Section | null = null
    public currentItems: Report127DailyTableRow[] = []
    public sectionOptions: Section[] = []
    // В случае если несколько регионов с подробными строками по каждой секций
    public regionSectionOptions: Section[] = []

    private indicatorKeys = ['utv', 'utch', 'plg', 'plgp', 'plgo', 'obz', 'nobz', 'sumrg', 'percentage1', 'percentage2']

    public indicatorsNameMap = {
        utv: 'Утвержденный бюджет на отчетный финансовый год',
        utch: 'Уточненный бюджет на отчетный финансовый год',
        plg: 'Скорректированный бюджет на отчетный финансовый год',
        plgs: 'Сводный план поступлений и финансирования по платежам, сводный план финансирования по обязательствам на отчетный период',
            plgp: 'по платежам',
            plgo: 'по обязательствам',
        obz: 'Принятые обязательства',
        nobz: 'Неоплаченные обязательства',
        sumrg: 'Исполнение поступлений бюджета и/или оплаченных обязательств по бюджетным программам (подпрограммам)',
        percentage1: 'Исп-е поступ-ий бюджета и/или оплач. обяз-в по бюдж. прогр. (подпрогр.)  к свод. плану  поступ-ий и финанс-ия  на отчет. период, %',
        percentage2: 'Исп-е поступ-ий бюджета и/или оплач. обяз-ва по бюдж. прогр. (подпрогр.) к исполняемому бюджету, %',
    }

    get totalColumnSpan(): number {
        let span = 0
        for (const field of this.tableFields) {
            if (this.indicatorKeys.includes(field.key)) {
                break
            }
            span++
        }
        return span
    }

    get categoriesSpan(): number {
        const activeIncomes = this.incomes.filter(item => item.active)
        const activeExpenses = this.expenses.filter(item => item.active)
        return activeExpenses.length > activeIncomes.length ? activeExpenses.length : activeIncomes.length
    }

    private created() {
        this.indicators = cloneDeep(this.propIndicators)
        this.constructTableFields(true)
        this.fillSections()
    }

    private fillSections() {
        // Защита от пустых данных
        if (!this.tableData || this.tableData.length === 0) {
            this.regionSectionOptions = [{ key: 'Нет данных', value: [{ key: 'Нет данных', value: [] }] }]
            this.selectedRegion = this.regionSectionOptions[0]
            this.sectionOptions = this.selectedRegion.value
            this.selectedSection = this.sectionOptions[0]
            this.currentItems = []
            return
        }

        const tempRegionOptions: Section[] = []
        let tempTableRows = cloneDeep(this.tableData)

        // Добавляем дефолтный REGION-разделитель если данные не начинаются с него
        if (
            ('type' in tempTableRows[0] && tempTableRows[0].type !== 'REGION')
            || !('type' in tempTableRows[0])
        ) {
            const separator: SectionSeparator = { 'name': '', type: 'REGION' }
            tempTableRows = [separator as Report127DailyRow].concat(tempTableRows)
        }

        let currentRegionRows: Report127DailyTableRow[] = []
        let index = 0
        tempTableRows.forEach(row => {
            if ('type' in row) {
                if (row.type === 'REGION') {
                    // Новый регион — сохраняем предыдущий
                    currentRegionRows = []
                    tempRegionOptions.push({ key: row.name, value: [{ key: '', value: currentRegionRows }] })
                } else if (row.type === 'SECTION') {
                    // Секцию превращаем в строку-разделитель с жирным названием
                    if (row.name) {
                        const sectionRow: Report127DailyTableRow = {
                            index: index++,
                            gr: null,
                            pgr: null,
                            abp: null,
                            prg: null,
                            ppr: null,
                            epcl: null,
                            espf: null,
                            gu: null,
                            kat: null,
                            cls: null,
                            pcl: null,
                            spf: null,
                            nameRu: row.name,
                            nameKk: null,
                            utv: null,
                            utch: null,
                            plg: null,
                            plgp: null,
                            plgo: null,
                            obz: null,
                            nobz: null,
                            sumrg: null,
                            percentage1: null,
                            percentage2: null,
                            bold: true
                        }
                        currentRegionRows.push(sectionRow)
                    }
                }
            }
            else {
                row.index = index++
                currentRegionRows.push(row)
            }
        })

        this.regionSectionOptions = tempRegionOptions

        this.selectedRegion = tempRegionOptions[0]

        this.sectionOptions = tempRegionOptions[0].value
        this.selectedSection = tempRegionOptions[0].value[0] as Section

        this.handlePageChange(1)
    }

    private constructTableFields(isOnCreate: boolean) {
        const tempTableFields: TableField[] = []
        tempTableFields.push({ key: 'codes', label: 'Коды бюджетной классификации', active: true })

        let tempIncomes = cloneDeep(this.incomes)
        let tempExpenses = cloneDeep(this.expenses)

        if (tempIncomes.length == 0) {
            tempIncomes = [{ key: 'temp_income', selected: [], active: true }]
        }
        if (tempExpenses.length == 0) {
            tempExpenses = [{ key: 'temp_expenses', selected: [], active: true }]
        }

        const activeIncomes = tempIncomes.filter(item => item.active)
        const activeExpenses = tempExpenses.filter(item => item.active)

        activeExpenses.forEach(it => {
            if (it.key === 'spf') {
                it.key = 'espf'
            }
            if (it.key === 'pcl') {
                it.key = 'epcl'
            }
        })

        const categoriesSpan = this.categoriesSpan === 0 ? 1 : this.categoriesSpan

        const tempCategoryFields: TableField[] = []
        for (let i = 0; i < categoriesSpan; i++) {
            const incomeKey = activeIncomes[i]?.key
            const expenseKey = activeExpenses[i]?.key
            // @ts-ignore
            const incomeLabel = nameMap[incomeKey]
            // @ts-ignore
            const expenseLabel = nameMap[expenseKey]

            const field: TableField = {
                key: `${incomeKey}/${expenseKey}`,
                label: `${incomeLabel??' - '}/${expenseLabel??' - '}`,
                income: incomeKey,
                expense: expenseKey,
                classification: incomeKey ?? expenseKey,
                active: true
            }
            tempCategoryFields.push(field)
        }
        // Добавляем столбик ГУ если разрезность ГУ активна
        // Позиция зависит от порядка в разрезности: до КБК → первый, после КБК → последний
        if (this.segmentations.includes('GU')) {
            const guField: TableField = {
                key: 'gu',
                label: ' - /ГУ',
                income: undefined,
                expense: 'gu',
                active: true
            }
            const kbkIdx = this.segmentations.indexOf('KBK')
            const guIdx = this.segmentations.indexOf('GU')
            if (kbkIdx === -1 || guIdx < kbkIdx) {
                // ГУ перед КБК или КБК нет — столбец первый
                tempCategoryFields.unshift(guField)
            } else {
                // ГУ после КБК — столбец последний
                tempCategoryFields.push(guField)
            }
        }

        this.categoryFields = tempCategoryFields

        tempTableFields.push({ key: 'nameRu', label: 'Наименование', active: true })

        const indicators = isOnCreate ? this.propIndicators : this.indicators

        indicators.filter(it => it.active).forEach(indicator => {
            // @ts-ignore
            tempTableFields.push({ key: indicator.key, label: this.indicatorsNameMap[indicator.key], active: true })
        })

        this.tableFields = tempTableFields
    }

    public handlePageChange(page: number) {
        const indexedPage = page - 1
        this.currentPage = page
        const startIndex = indexedPage * 100
        const endIndex = startIndex + 100
        this.currentItems = this.selectedSection!.value.slice(startIndex, endIndex)
    }

    public onRegionChange(regionSection: Section) {
        if (this.selectedRegion) {
            const options = this.regionSectionOptions.find(it => it.key === regionSection.key)!
            this.sectionOptions = options.value
            this.selectedSection = (regionSection.value[0] as Section)
        }
        this.handlePageChange(1)
    }

    public onSectionChange() {
        this.handlePageChange(1)
    }

    public draggableHeader(columnKey: string) {
        return this.indicatorKeys.includes(columnKey)
    }

    public isTotalColumn(columnKey: string) {
        return ['plan', 'fact', 'delta1'].includes(columnKey)
    }

    public synchronizeIndicatorsOrder() {
        const fullIndicatorKeys = this.indicatorKeys.filter(it => ['plgp', 'plgo'].notIncludes(it)).concat(['plgs'])
        const indicatorsOrder = this.tableFields
            .filter(it => fullIndicatorKeys.includes(it.key))
            .map(it => it.key)

            fullIndicatorKeys.forEach(indicatorKey => {
            if (indicatorsOrder.notIncludes(indicatorKey)) {
                indicatorsOrder.push(indicatorKey)
            }
        })

        const tempIndicators: Indicator[] = []
        indicatorsOrder.forEach(indicatorKey => {
            const IndicatorObject = this.indicators.find(it => it.key === indicatorKey)!
            tempIndicators.push(IndicatorObject)
        })

        this.indicators = tempIndicators
        this.$emit('update-indicators', tempIndicators)
    }

    public synchronizeVisiblityInTable() {
        this.$emit('update-indicators', cloneDeep(this.indicators))
        this.constructTableFields(false)
    }

    /** Метод-обертка для $t (возвращает казахский перевод) */
    public tr(key: any): string {
        if (typeof key !== 'string') {
            return ''
        }
        const translationKey = 'modules.budget_execution_monitoring.reports_constructor.1_27'
        const text: string = String(this.$t(`${translationKey}.${key}`, 'kk'))
        return text
    }

    public getCategoryLabel(column: TableField): string {
        if (this.i18nService.locale !== 'kk') return column.label
        const incomeLabel = column.income ? this.tr(column.income) : ' - '
        const expenseLabel = column.expense ? this.tr(column.expense) : ' - '
        return `${incomeLabel}/${expenseLabel}`
    }

    public formatDigitsGrouping = formatDigitsGrouping
    public padLeadingZeros = padLeadingZeros
}
